<template>

  <section class="content">

    <demande-modal title="Annuler une demande"
           v-on:close="doCloseAnyModals"
           v-if="deleteModal === true">
      <demande-delete slot="body"
                       v-on:close="doCloseAnyModals"
                       :demande="demande"></demande-delete>
    </demande-modal>

    <demande-modal title="Modifier une demande"
           v-on:close="doCloseAnyModals"
           v-if="updateModal === true">
      <demande-form slot="body"
                     v-on:close="doCloseAnyModals"
                     :update-demande="demande"></demande-form>
    </demande-modal>

    <demande-modal :title=getErrorTitle
                   v-on:close="doCloseAnyModals"
                   v-if="getErrorCancellation">
      <error-modal slot="body"
                      v-on:close="doCloseAnyModals"
                      :demande="demande"></error-modal>
    </demande-modal>

    <demande-modal title="Créer une nouvelle demande"
           v-on:close="doCloseAnyModals"
           v-if="createModal === true">
      <demande-form slot="body"
                     v-on:close="doCloseAnyModals"></demande-form>
    </demande-modal>

    <section class="content-toolbar">
      <div class="btn btn-primary"
           v-on:click="clickCreate()">Créer une nouvelle demande</div>
      <div class="btn btn-primary"
           v-on:click="exportDemandes()">Exporter toutes les demandes</div>
    </section>

    <demandes-list v-on:delete="clickDelete"
                   v-on:edit="clickEdit">
    </demandes-list>

  </section>
</template>

    <script>
    import DemandesList from './DemandesList'
    import DemandeDelete from './DemandeDelete'
    import DemandeForm from './DemandeForm'
    import DemandeModal from '../commons/DemandeModal'
    import * as demandeStatut from './../../../utils/demandeStatut'
    import ErrorModal from "./ErrorModal.vue";

    export default {
      components: {
        ErrorModal,
        DemandesList,
        DemandeDelete,
        DemandeForm,
        DemandeModal,
      },
      data: function () {
        return {
          deleteModal: false,
          updateModal: false,
          createModal: false,
          demande: null,
        }
      },
      computed: {
        getErrorCancellation() {
          return this.$store.state.demandes.cancellationError !== '';
        },
        getErrorTitle() {
          return this.$store.state.demandes.cancellationError.includes("annulée,") ? "Annuler une demande" : "Modifier une demande";
        },
      },
      methods: {
        clickDelete: function (demande) {
            this.demande = demande
            this.deleteModal = true

        },
        clickEdit: function (demande) {
          this.demande = demande
          this.updateModal = true
        },
        clickCreate: function () {
          console.log("staterrrrrrr",this.$store.state.currentVille)
          this.createModal = true
        },
        doCloseAnyModals: function () {

          this.updateModal = false
          this.createModal = false
          this.deleteModal = false
          this.$store.dispatch('clearDemandeCancellationErrors')
        },
        exportDemandes: function () {
          console.log('Generate demandes reporting')
          //this.$store.dispatch('generateDemandesReporting')
          this.$store.dispatch('generateDemandesReporting')
        },
      },
      mounted: function () {
        console.log("create modal ===============",this.createModal)
      },
    }
    </script>

    <style lang="scss">

    </style>



// WEBPACK FOOTER //
// Demande.vue?46c208a2